/** Available HTTP methods for APIs */
export enum HttpMethodEnum {
  /** HTTP GET request method (for read APIs) */
  GET = 'GET',
  /** HTTP POST request method (for create APIs) */
  POST = 'POST',
  /** HTTP PUT request method (for update APIs) */
  PUT = 'PUT',
  /** HTTP DELETE request method (for delete APIs) */
  DELETE = 'DELETE',
  /** HTTP PATCH request method (for update APIs) */
  PATCH = 'PATCH',
}
